import { createAsyncThunk } from "@reduxjs/toolkit";
import { db } from "../../../firebase/config";
import firebase from "firebase";
import FieldPath = firebase.firestore.FieldPath;
import { SiteStateResponse } from "../../../utils/types/SiteStateResponse";

export const setSiteVisibility = createAsyncThunk(
  "site/setVisibility",
  async (siteState: SiteStateResponse) => {
    try {
      const querySnapshot = await db
        .collection("state")
        .where(FieldPath.documentId(), "==", "site")
        .get();

      if (process.env.NODE_ENV === "development") {
        await querySnapshot.docs[0].ref.set({
          ...siteState,
          isLocalOnline: !siteState.isLocalOnline,
        });
        return !siteState.isLocalOnline;
      } else {
        await querySnapshot.docs[0].ref.set({
          ...siteState,
          isOnline: !siteState.isOnline,
        });
        return !siteState.isOnline;
      }
    } catch (e: any) {
      console.log(e);

      if (process.env.NODE_ENV === "development") {
        return Promise.reject(
          `Sito non ${!siteState.isLocalOnline ? "mostrato" : "nascosto"}, ${e.message}`,
        );
      } else {
        return Promise.reject(
          `Sito non ${!siteState.isOnline ? "mostrato" : "nascosto"}, ${e.message}`,
        );
      }
    }
  },
);
